import React from 'react';

type StatusProps = {
  value: boolean;
  onChange: () => Promise<void>;
};

export const Status: React.FC<StatusProps> = ({ value, onChange }) => {
  return (
    <span className="tb-product">
      {value ? (
        <span
          className="badge bg-secondary"
          style={{ cursor: 'pointer' }}
          onClick={() => onChange()}
        >
          Ativo
        </span>
      ) : (
        <span
          className="badge bg-danger"
          style={{ cursor: 'pointer' }}
          onClick={() => onChange()}
        >
          Desativado
        </span>
      )}
    </span>
  );
};
